if (!customElements.get('pivot-variant-nutrition')) {
  customElements.define('pivot-variant-nutrition', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.onVariantChange = (event) => {
        const id = String(event.detail?.variant?.id ?? '');
        const panels = [...this.querySelectorAll('[data-variant-id]')];
        if (id && !panels.some((panel) => panel.dataset.variantId === id)) return;
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.variantId !== id;
        });
      };
      this.section?.addEventListener('on:variant:change', this.onVariantChange);
      document.addEventListener('variant:changed', this.onVariantChange);
    }
    disconnectedCallback() {
      this.section?.removeEventListener('on:variant:change', this.onVariantChange);
      document.removeEventListener('variant:changed', this.onVariantChange);
    }
  });
}
